$(function() {
  var currentUrl = document.location.href; //todo: add utm
  var title = window.title;
  var image = window.image;
  var shortUrl = window.shortUrl;

  $('.share-facebook').on('click', function shareToFacebook() {
    var shareUrl = 'https://www.facebook.com/sharer/sharer.php';
    shareUrl += '?u=';
    shareUrl += encodeURIComponent(currentUrl);
    window.open(shareUrl, 'facebookShare', 'height=300,width=600');
    return false;
  });

  $('.share-twitter').on('click', function shareToTwitter() {
    var shareUrl = 'https://twitter.com/share';
    shareUrl += '?url=';
    if (shortUrl) {
      shareUrl += encodeURIComponent(shortUrl);
    } else {
      shareUrl += encodeURIComponent(currentUrl);
    }
    shareUrl += "&text=" + title;
    if (image) {
      shareUrl += "&image=" + image;
    }
    shareUrl += '&via=ekmekvegul';
    window.open(shareUrl, 'twitterShare', 'height=300,width=600');
    return false;
  });

  $('.share-pinterest').on('click', function shareToTwitter() {
    var shareUrl = 'http://pinterest.com/pin/create/button/';
    shareUrl += '?url=';
    shareUrl += encodeURIComponent(currentUrl);
    shareUrl += '&description=ekmekvegul.net';
    window.open(shareUrl, 'pinterestShare', 'height=300,width=600');
    return false;
  });
});